import { useEffect, useState, useRef } from "react";
import {
  TileLayer,
  FeatureGroup,
  MapContainer,
  Marker,
  Polygon,
} from "react-leaflet";
import { EditControl } from "react-leaflet-draw";
import { FullscreenControl } from "react-leaflet-fullscreen";
import { toastError } from "utils/toasters";

// components
import ChangeMapView from "./ChangeMapView";

const MapHolder = ({ mode, rowData, onCoordsUpdate, coords }) => {
  const [center, setCenter] = useState(["", ""]);
  const [markerPosition, setMarkerPosition] = useState({ lat: "", lng: "" });
  const timerRef = useRef();

  const handleEdit = (e) => {
    e.layers.eachLayer((ele) => {
      onCoordsUpdate(ele.getLatLngs()[0]);
    });
  };

  const handleDelete = (e) => {
    if (e.layers.getLayers().length === 0) {
      return;
    }
    onCoordsUpdate(null);
  };

  const handleCreate = (e) => {
    onCoordsUpdate(e.layer.getLatLngs()[0]);
  };

  useEffect(() => {
    clearTimeout(timerRef.current);
    timerRef.current = setTimeout(() => {
      window.dispatchEvent(new Event("resize"));
    }, 1000);
    return () => clearTimeout(timerRef.current);
  }, []);

  useEffect(() => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          if (mode !== "edit" || !rowData?.boundaries.length) {
            const centerCoords = [
              position.coords.latitude,
              position.coords.longitude,
            ];
            setCenter(centerCoords);
          }
          setMarkerPosition({
            lat: position.coords.latitude,
            lng: position.coords.longitude,
          });
        },
        (error) => {
          toastError(error.message);
        },
        {
          enableHighAccuracy: true,
          maximumAge: 2000,
          timeout: 5000,
        }
      );
    }
    if (mode === "edit" && rowData?.boundaries.length) {
      let totalLatitudes = 0,
        totalLongitudes = 0;
      rowData.boundaries.forEach((boundary) => {
        totalLatitudes += parseFloat(boundary.latitude);
        totalLongitudes += parseFloat(boundary.longitude);
      });
      const polygonCenterX = totalLatitudes / rowData.boundaries.length;
      const polygonCenterY = totalLongitudes / rowData.boundaries.length;
      setCenter([`${polygonCenterX}`, `${polygonCenterY}`]);
    }
  }, [mode, rowData]);

  return (
    <MapContainer
      style={{ height: "300px" }}
      center={center}
      zoom={11}
      scrollWheelZoom={true}
      worldCopyJump={true}
      key={mode === "edit" ? coords : 0}
    >
      <ChangeMapView center={center} />
      <FeatureGroup key={`feature-${coords}`}>
        <EditControl
          position="topright"
          onEdited={handleEdit}
          onCreated={handleCreate}
          onDeleted={handleDelete}
          draw={{
            rectangle: false,
            circle: false,
            marker: false,
            polyline: false,
            circlemarker: false,
            polygon: !coords,
          }}
        />
        <Polygon positions={coords || []} />
      </FeatureGroup>
      <TileLayer
        key={`tile-${coords}`}
        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        noWrap
      />
      <FullscreenControl />
      <Marker position={markerPosition} />
    </MapContainer>
  );
};

export default MapHolder;
